import { Space, Input, Typography, Checkbox } from 'antd';
import { QUESTION_TYPE } from 'types/Enum';
// import { useTheme } from 'utils/Theme';
import {
  Container,
  InputContainer,
  StyledRate,
  RatingDescContainer,
} from './SurveyInput.style';
import React from 'react';
import {quadtree} from 'd3';

const { Title } = Typography;
const { TextArea } = Input;

export interface SurveyInputProps {
  type: QUESTION_TYPE;
  onChange: (value: string) => void;
  value: string;
  optionsLabels?: (txt: string) => string;
}

const SurveyInput = (props: SurveyInputProps): JSX.Element => {
  const { type, onChange, value, optionsLabels = x => x } = props;
  if (type === QUESTION_TYPE.Points) {
    console.log({ type, points: QUESTION_TYPE.Points });
    return (
      <Space size={8} direction="vertical" style={{ width: '100%' }}>
        <RatingDescContainer>
          <p>{optionsLabels('Strongly Disagree')}</p>
          <p>{optionsLabels('Disagree')}</p>
          <p>{optionsLabels('Neutral')}</p>
          <p>{optionsLabels('Agree')}</p>
          <p>{optionsLabels('Strongly Agree')}</p>
        </RatingDescContainer>
        <StyledRate
          onChange={(val: {toString: () => string;}) => onChange(val.toString())}
          value={+value}
        />
      </Space>
    );
  }

  if (type === QUESTION_TYPE.Input) {
    console.log({ type, points: QUESTION_TYPE.Points });
    return (
      <InputContainer>
        <TextArea
          showCount
          maxLength={350}
          onChange={(e) => onChange(e.target.value)}
          value={value}
        />
      </InputContainer>
    );
  }

  if (type === QUESTION_TYPE.Booblean) {
    console.log({ type, points: QUESTION_TYPE.Points });
    return (
      <Space size={8} direction="vertical" style={{ width: '100%' }}>
        <Checkbox
          style={{ fontSize: '24' }}
          onChange={() => onChange('true')}
          checked={value === 'true'}
        >
          Yes
        </Checkbox>
        <Checkbox
          style={{ fontSize: '24' }}
          onChange={() => onChange('false')}
          checked={value === 'false'}
        >
          No
        </Checkbox>
      </Space>
    );
  }

  if (type === QUESTION_TYPE.Numeric) {
    console.log({ type, points: QUESTION_TYPE.Points });
    return (
      <InputContainer>
        <Input
          size="middle"
          placeholder="Enter value between 0% - 100%"
          max={100}
          min={0}
          onChange={(e) => {
            if (!isNaN(+e.target.value)) {
              if (+e.target.value >= 0 && +e.target.value <= 100)
                onChange(e.target.value);
            }
          }}
          value={value}
        />
      </InputContainer>
    );
  }

  console.log({ default: true });
  return <Container />;
};

export default React.memo(SurveyInput);
